'use client'

import {useEffect} from 'react'
import {useGamePlayerAds} from '@app/components/game-player/context/gameplayer-ads-context/gameplayer-ads-context'

const PrerollAdOnPageLoad = () => {
  const {showPrerollAd} = useGamePlayerAds()
  useEffect(() => {
    showPrerollAd()
  }, [showPrerollAd])
  return null
}

export default PrerollAdOnPageLoad
